// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__C03R6","image":"Header_image__2fAN7","name":"Header_name__1npeq","info":"Header_info__3V6jU","infoRow":"Header_infoRow__3vNZJ"};